import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-maticon',
	templateUrl:'./MatIconPage.html',
	styles: [],
	styleUrls:['./MatIconPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatIconPage
{
	mdContent_256 = `\`\`\`java
import com.jwebmp.plugins.angular.material.MatIcon;
\`\`\``;
	mdContent_257 = `\`\`\`java
MatIcon()
\`\`\``;
	mdContent_258 = `\`\`\`java
MatIcon(String ligature)
\`\`\``;
	mdContent_259 = `\`\`\`java
MatIcon&lt;?&gt; icon = new MatIcon&lt;&gt;("home");
icon.setColor("primary");
icon.setInline(true);
\`\`\``;
}
